export default __webpack_public_path__ + "static/media/RedHatDisplay-Bold.c7f567b8.ttf";